import React from 'react';
import {
  Grid,
  Typography,
} from '@mui/material';

const Benefit: React.FC<{icon: React.ReactNode, text: React.ReactNode}> = ({ icon, text }) => (
  <Grid container alignItems="center" gap={1}>
    <Grid size={1}>
      {icon}
    </Grid>
    <Grid size={10}>
      <Typography fontSize={14}>
        {text}
      </Typography>
    </Grid>
  </Grid>
);

export default Benefit;
